var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"vegcards"},[_c('h2',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.msg))]),_c('div',{staticClass:"row"},_vm._l((_vm.filterCards(
            _vm.statestate,
            _vm.monthmonth,
            _vm.card,
            _vm.$cards
          )),function(card,index){return _c('div',{key:index,staticClass:"col xl2 vegCard",staticStyle:{"padding":"0 20px"}},[_c('div',{staticClass:"card"},[_c('router-link',{attrs:{"to":{
                name: 'vegdetail',
                params: { card: _vm.toURL(card.name), state: _vm.toURL(_vm.statestate) },
              }},on:{"click":function($event){return _vm.$router.go()}}},[_c('img',{staticClass:"card-image1",attrs:{"src":_vm.getImgUrl(card.image),"alt":card.image,"loading":"lazy","width":"195px","height":"103px"}})]),_c('div',{staticClass:"cardTop",staticStyle:{"padding-bottom":"0"}},[_c('router-link',{attrs:{"to":{
                  name: 'vegdetail',
                  params: {
                    card: _vm.toURL(card.name),
                    state: _vm.toURL(_vm.statestate),
                  },
                }}},[_c('h3',{staticClass:"card_title"},[_vm._v(_vm._s(card.name))])])],1),_c('div',{staticClass:"card-body"},[_c('router-link',{attrs:{"to":{
                  name: 'vegdetail',
                  params: {
                    card: _vm.toURL(card.name),
                    state: _vm.toURL(_vm.statestate),
                  },
                }}},[_c('p',{staticClass:"card-content"},[_vm._v(_vm._s(card.desc))])])],1),_c('div',{staticClass:"card_action"},[_c('router-link',{staticClass:"btn-outline-primary",attrs:{"to":{
                  name: 'vegdetail',
                  params: {
                    card: _vm.toURL(card.name),
                    state: _vm.toURL(_vm.statestate),
                  },
                }}},[_vm._v("Seasonality")])],1)],1)])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }